function init (sectionId) {
  'use strict';

  /* ── Video play-on-click ──────────────────────────────────── */
  var vidWrap = document.getElementById(`by-sbs-vid-${sectionId}`);
  if (vidWrap) {
    var cover  = vidWrap.querySelector('.by-sbs__video-cover');
    var video  = vidWrap.querySelector('.by-sbs__video');
    var playBtn = vidWrap.querySelector('.by-sbs__play-btn');

    if (cover && video && playBtn) {
      playBtn.addEventListener('click', function () {
        cover.style.display = 'none';
        video.controls = true;
        video.play();
      });
    }
  }

  /* ── Countdown timer ──────────────────────────────────────── */
  var timerEl = document.getElementById(`by-sbs-timer-${sectionId}`);
  if (!timerEl) return;

  var targetStr = timerEl.getAttribute('data-timer-target');
  if (!targetStr) return;

  var targetTime = new Date(targetStr).getTime();
  if (isNaN(targetTime)) return;

  var daysEl  = timerEl.querySelector('[data-timer-days]');
  var hoursEl = timerEl.querySelector('[data-timer-hours]');
  var minsEl  = timerEl.querySelector('[data-timer-mins]');
  var secsEl  = timerEl.querySelector('[data-timer-secs]');

  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  function tick() {
    var distance = targetTime - Date.now();

    if (distance <= 0) {
      daysEl.textContent  = '00';
      hoursEl.textContent = '00';
      minsEl.textContent  = '00';
      secsEl.textContent  = '00';
      return;
    }

    daysEl.textContent  = pad(Math.floor(distance / 86400000));
    hoursEl.textContent = pad(Math.floor((distance % 86400000) / 3600000));
    minsEl.textContent  = pad(Math.floor((distance % 3600000) / 60000));
    secsEl.textContent  = pad(Math.floor((distance % 60000) / 1000));
  }

  tick();
  setInterval(tick, 1000);

}

window.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('.by-sbs-parent')
    sections.forEach((section) => {
        const sectionId = section.dataset.sectionId;
        init(sectionId)
    })
})